import React, { useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  Sekcja,
  Zdjecie,
  Tytul,
  Podtytul,
  Opis,
  Kontener,
  Oswiadczenie,
  Dane,
  Wiersz,
  Paragraf,
  Input,
  Select,
  Textarea,
  Button,
  StyledLink,
  Przyciski,
  Telefon,
} from "./styled";
import sekcja9 from "../../../images/sekcja-9-pawel.webp";
import { getLeadAttribution, pushDataLayer } from "../../../analytics";
import Contact from "../../../constants";
import { contactEndpointForHost, contactResponseAccepted } from "../../../contactEndpoint";

const Formularz = () => {
  const history = useHistory();
  const { search } = useLocation();
  const [status, setStatus] = useState("idle");
  const [attribution] = useState(getLeadAttribution);
  const formStarted = useRef(false);
  const allowedTopics = ["zakup-wtorny", "zakup-deweloper", "budowa", "refinansowanie", "gotowkowy", "dokumenty", "ubezpieczenie-zycie", "firma", "rkm", "pozyczka-hipoteczna", "leasing", "inne"];
  const topicFromLink = new URLSearchParams(search).get("topic") || "";
  const initialTopic = allowedTopics.includes(topicFromLink) ? topicFromLink : "";
  const scrollToUp = () => window.scrollTo({ top: 0 });

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus("submitting");
    const myForm = event.target;
    const formData = new FormData(myForm);
    try {
      const response = await fetch(contactEndpointForHost(window.location.hostname), {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData).toString(),
      });
      if (!await contactResponseAccepted(response, window.location.hostname)) throw new Error("Zgłoszenie nie zostało przyjęte.");
      setStatus("success");
      pushDataLayer("sf_form_submit_success", { topic: formData.get("topic") || "unknown" });
      myForm.reset();
      history.push("/dziekujemy");
    } catch (error) {
      setStatus("error");
      pushDataLayer("sf_form_submit_error");
    }
  };

  const handleFormFocus = () => {
    if (formStarted.current) return;
    formStarted.current = true;
    pushDataLayer("sf_form_start");
  };

  return (
    <Sekcja id="formularz">
      <Zdjecie
          src={sekcja9}
          alt="Paweł Kowalewski w biurze Serce Finansów w Suwałkach"
          width="847"
          height="877"
          loading="lazy"
          decoding="async"
        />
      <Opis>
        <div id="formularz-pola" style={{ scrollMarginTop: 100 }}>
          <Tytul>{initialTopic === "ubezpieczenie-zycie" ? "Porozmawiajmy o ochronie rodziny" : ["firma", "leasing"].includes(initialTopic) ? "Omów finansowanie swojej firmy" : "Umów bezpłatną konsultację kredytową"}</Tytul>
          <Podtytul>Zostaw kontakt. Porozmawiamy o Twoich planach i ustalimy pierwszy krok.</Podtytul>
        </div>
        <Kontener
          name="contact"
          method="POST"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          onSubmit={handleSubmit}
          onFocusCapture={handleFormFocus}
        >
          <input type="hidden" name="form-name" value="contact" />
          <input type="hidden" name="bot-field" />
          {Object.entries(attribution).map(([name, value]) => (
            <input key={name} type="hidden" name={name} value={value} />
          ))}
          <Dane>
            <Wiersz>
              <Paragraf>Imię* </Paragraf>
              <Input name="name" type="text" required autoComplete="given-name" />
            </Wiersz>
            <Wiersz>
              <Paragraf>Nr telefonu* </Paragraf>{" "}
              <Input
                name="phone"
                type="tel"
                required
                pattern={String.raw`\+?(?:[ \(\)\.\-]*[0-9]){9,15}[ \(\)\.\-]*`}
                minLength="9"
                maxLength="30"
                title="Wpisz numer telefonu, np. 783 737 050 lub +48 783 737 050"
                autoComplete="tel"
              />
            </Wiersz>
            <Wiersz>
              <Paragraf>Adres e-mail <small>(opcjonalnie)</small></Paragraf>{" "}
              <Input name="email" type="email" autoComplete="email" />
            </Wiersz>
          </Dane>

          <Wiersz>
            <Paragraf>W czym możemy pomóc?*</Paragraf>
            <Select key={initialTopic} name="topic" required defaultValue={initialTopic}>
              <option value="" disabled>Wybierz temat</option>
              <option value="zakup-wtorny">Zakup mieszkania lub domu z rynku wtórnego</option>
              <option value="zakup-deweloper">Zakup od dewelopera lub z rynku pierwotnego</option>
              <option value="budowa">Budowa domu</option>
              <option value="refinansowanie">Refinansowanie, przeniesienie lub audyt kredytu</option>
              <option value="gotowkowy">Kredyt gotówkowy lub konsolidacja</option>
              <option value="dokumenty">Weryfikacja transakcji i dokumentów</option>
              <option value="ubezpieczenie-zycie">Ubezpieczenie na życie</option>
              <option value="firma">Finansowanie firmy</option>
              <option value="leasing">Leasing samochodu, sprzętu lub maszyn</option>
              <option value="rkm">RKM i wkład własny</option>
              <option value="pozyczka-hipoteczna">Pożyczka hipoteczna</option>
              <option value="inne">Inna sprawa</option>
            </Select>
          </Wiersz>

          <div>
            <Wiersz>
              <Paragraf>Wiadomość <small>(opcjonalnie)</small></Paragraf>
              <Textarea name="message" autoComplete="off" />
            </Wiersz>
          </div>
          <details className="consultation-details"><summary>Jak wygląda kontakt?</summary><p>Odpowiemy telefonicznie lub e-mailem, zwykle w ciągu jednego dnia roboczego. Rozmowa i obsługa kredytowa nie wiążą się dla klienta z dodatkową opłatą. Wynagrodzenie za obsługę kredytu otrzymujemy od banku.</p></details>
          <Oswiadczenie>
            Informacje o przetwarzaniu danych znajdziesz w{" "}
            <StyledLink to="/polityka-prywatności" onClick={scrollToUp}>
              Polityce Prywatności
            </StyledLink>. Zobacz również{" "}
            <StyledLink to="/regulamin" onClick={scrollToUp}>
              Regulamin
            </StyledLink>. Nie przesyłaj numeru PESEL, skanów dokumentów ani danych dotyczących zdrowia.
          </Oswiadczenie>
          <Przyciski>
            <p>
              <Button type="submit" disabled={status === "submitting"}>
                {status === "submitting" ? "Wysyłanie…" : "Poproś o kontakt"}
              </Button>
            </p>
            <Telefon href={`tel:${Contact.PHONE}`} data-phone-person="pawel">
              Wolisz zadzwonić? <strong>783 737 050</strong>
            </Telefon>
            {status === "success" && (
              <p role="status">
                Wiadomość została wysłana! <br /> Dziękujemy za kontakt.
              </p>
            )}
            {status === "error" && (
              <p role="alert">Nie udało się wysłać wiadomości. Spróbuj ponownie lub zadzwoń pod numer 783 737 050.</p>
            )}
          </Przyciski>
        </Kontener>
      </Opis>
    </Sekcja>
  );
};

export default Formularz;

